<template>
    <div class="eco-mobilier-modal">
        <global-modal
            v-if="isOpen"
            :width="600"
            @hide="isOpen = false"
        >
            <div class="eco-mobilier-modal-inside" v-html="t('eco-mobilier-details', {price: getPrice()})"/>
        </global-modal>
        <span class="eco-mobilier-activator">
            <a href="#" @click.prevent="isOpen = true">{{ linkLabel }}</a>
            {{ afterLinkLabel }}
        </span>
    </div>
</template>

<script setup lang="ts">
import {ref, computed} from 'vue';
import {useI18n} from 'vue-i18n';
import GlobalModal from './Modal.vue';

interface Props {
    price?: string | number;
    label?: string;
}

const {price: priceProp, label} = defineProps<Props>();

const {t} = useI18n();
const isOpen = ref(false);

const linkLabel = computed(() => {
    return t(label ?? 'conf2-eco-mobilier-info-link');
});

const afterLinkLabel = computed(() => {
    return label ? '' : t('conf2-eco-mobilier-info');
});

const getPrice = () => {
    if (priceProp) {
        return priceProp;
    }

    const priceInput = document.querySelector('input[name=eco-mobilier-price]') as HTMLInputElement | null;
    return Number(priceInput?.value ?? 0);
};
</script>

<style lang="scss" scoped>
.eco-mobilier-modal {
    display: inline;

    .global-modal {
        font-size: initial;
        color: initial;
    }
}

.eco-mobilier-modal-inside {
    padding: 60px 80px;
}

#configuratorFormWandboard {
    .eco-mobilier-activator {
        font-size: 9px;

        a {
            text-decoration: underline;

            &.hover {
                text-decoration: none;
            }
        }
    }
}
</style>
